import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject } from 'rxjs';
import { IAPIResponse } from 'src/app/modules/shared/models';
import { ILineItemMarketResult, ISupplierMarketResult } from '../../../models';
import { PrBuyerDashboardService } from '../../../services/pr-buyer-dashboard.service';

@Component({
  selector: 'buyer-market-search',
  templateUrl: './market-search.component.html',
  styleUrls: ['./market-search.component.scss']
})
export class MarketSearchComponent implements OnInit {

  public lineItemMarketResult !: ILineItemMarketResult;
  public lineItemDescription !: string;
  public title !: string;

  public onClose = new BehaviorSubject<any>({});
  public marketResults : Array<ISupplierMarketResult> = [];

  public showMaterialCodeResults : boolean = true;

  public selectedMarketResult : Record<string, boolean> = {}; // Hashmap for maintaining the selected market results with ID

  constructor(public bsModalRef: BsModalRef,
    private _toastr : ToastrService,
    private _buyerService : PrBuyerDashboardService) { }

  ngOnInit(): void {
  }

  public onModalClose(): void {
    this.bsModalRef.hide();
  }

  public closeModal(data ?: ISupplierMarketResult[]) {
    this.onClose.next(data);
    this.bsModalRef.hide();
  }

  public fetchMarketResults() : void {
    if(!this.lineItemDescription) return
    this.showMaterialCodeResults = true;
    this._buyerService.fetchMarketResults("", this.lineItemMarketResult.PURCH_ORG, this.lineItemMarketResult.COMP_CODE, this.lineItemDescription)
    .subscribe(({data : marketResults} : IAPIResponse<ISupplierMarketResult[]>) => {
      this.marketResults = marketResults;
      if(!marketResults.length) {
        this._toastr.error(`No results found for description ${this.lineItemDescription}, try another search`);
      }
    });
  }

  public reSearchMarketResult(MaterialNumber : string | undefined) {
    MaterialNumber && this._buyerService.fetchMarketResults(MaterialNumber, this.lineItemMarketResult.PURCH_ORG, this.lineItemMarketResult.COMP_CODE, "")
    .subscribe(({data : marketResults} : IAPIResponse<ISupplierMarketResult[]>) => {
      this.marketResults = marketResults;
      this.showMaterialCodeResults = false;
      if(!marketResults.length) {
        this._toastr.error(`No results found for ${MaterialNumber}, try another search`);
      }
    });
  }

  public toggleSelection(marketResultId : string) : void {
    if(this.selectedMarketResult && this.selectedMarketResult.hasOwnProperty(marketResultId)) {
      this.selectedMarketResult[marketResultId] = !this.selectedMarketResult[marketResultId];
    } else {
      this.selectedMarketResult[marketResultId] = true;
    }
  }

  public updateMarketResults() : void {
    if(!Object.keys(this.selectedMarketResult).length) return ;
    let results : ISupplierMarketResult[] = []; 
    Object.keys(this.selectedMarketResult).forEach((x : string) => {
      if(this.selectedMarketResult[x]) {
        const elem = this.marketResults.find(y=>y.ID === x);
        elem && results.push(elem)
      }
    });
    results?.length && this.closeModal(results);
  }

}
